import React from "react";

const Loader = () => {
  return (
    <div className="takaful--page-loader">
      {/* <Blocks wrapperClass='takaful--wrapper' height='80' width='80' color='#4fa94d' ariaLabel='blocks-loading' visible={true} /> */}
      <div className="loader" />
      <p className="takaful--loader-text">جاري تنفيذ العملية</p>
      <p className="takaful--loader-grey">نقدر لك انتظارك</p>
    </div>
  );
};

export default Loader;
